const cookie_name = 's_1'

import Cookies from 'js-cookie'

window.jQuery(document).ready(function(){
  if (document.getElementById('enable_user')) {
    console.log('Found enable_user element, setting cookie')
    Cookies.set(cookie_name, '1', { expires: 7 })
  }
})